import styled from 'styled-components';
import { timeDescription } from 'styles/parcelSharedStyles';

export const Description = styled.div`
  ${timeDescription}
`;
